import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=fdebf504&scoped=true&"
import script from "./shopDetails.vue?vue&type=script&lang=js&"
export * from "./shopDetails.vue?vue&type=script&lang=js&"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=fdebf504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdebf504",
  null
  
)

export default component.exports